/**
 *
 */
import * as type from './type';
import * as http from '../admin/axios/loginBefore';

const requestData = category => ({
    type: type.REQUEST_DATA,
    category
});
export const receiveData = (data, category) => ({
    type: type.RECEIVE_DATA,
    data,
    category
});
/**
 * 请求数据调用方法
 * @param funcName      请求接口的函数名
 * @param params        请求接口的参数
 */
export const fetchData = ({ funcName, params, stateName }) => dispatch => {
    !stateName && (stateName = funcName);
    dispatch(requestData(stateName));
    return new Promise((resolve, reject) => {
        http[funcName](params).then(function (res) {
            if (!res.error) {
                let user = {
                    roleId: res.roleId,
                    token: res.token,
                    userId: res.id,
                    userName: res.name,
                    langId: res.langId,
                    initialPasswordFlg: res.initialPasswordFlg,
                    deviceControl: 0,
                    departmentManagementAuth: 0,
                    categoryManagementAuth: 0,
                    logExport: 0,
                    contentMultipleRegistration: 0,
                    applicationImport: 0,
                    clientId: res.clientId,
                    activeDirectory: 0,
                    mailDelivery: 0,
                    pushDelivery: 0
                };
                let per = [];
                for (let key in res.menuRuleList) {
                    let value = res.menuRuleList[key];
                    if (!user.firstPage) {
                        user.firstPage = value.docMstRoleRulePK.ruleId;
                    }
                    per.push(value.docMstRoleRulePK.ruleId);
                }
                for (let key in res.ruleList) {
                    let value = res.ruleList[key];
                    if (value.docTblAdminUserRulePK.ruleId === 9) {
                        user.deviceControl = 1;
                    }
                    if (value.docTblAdminUserRulePK.ruleId === 5) {
                        user.categoryManagementAuth = 1;
                    }
                    if (value.docTblAdminUserRulePK.ruleId === 4) {
                        user.departmentManagementAuth = 1;
                    }
                    if (value.docTblAdminUserRulePK.ruleId === 11) {
                        user.logExport = 1;
                    }
                    if (value.docTblAdminUserRulePK.ruleId === 10) {
                        user.contentMultipleRegistration = 1;
                    }
                    if (value.docTblAdminUserRulePK.ruleId === 25) {
                        user.applicationImport = 1;
                    }
                    if (value.docTblAdminUserRulePK.ruleId === 26) {
                        user.activeDirectory = 1;
                    }
                    if (value.docTblAdminUserRulePK.ruleId === 27) {
                        user.pushDelivery = 1;
                    }
                    if (value.docTblAdminUserRulePK.ruleId === 28) {
                        user.mailDelivery = 1;
                    }
                    per.push(value.docTblAdminUserRulePK.ruleId);
                }
                dispatch(receiveData({ permissions: per, ...user }, stateName))
            } else {
                reject(res.errorMessage);
            }
        }).catch(function (error) {
            reject(error);
        });
    });
};